import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Card} from 'react-bootstrap';
import { LAYOUT } from 'constants.js';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import Clamp from 'components/clamp';
import {format} from 'date-fns';
import _ from 'lodash';
import PropTypes from 'prop-types';

const WorkexCard = ({user, workex, ...props}) => {
  
  return (
    <Card className="mb-5">
      <Card.Body>
        <Row className="g-0 sh-6">
          <Col xs="auto" className="me-3">
            {(workex.icon && workex.icon!=="")?<img className="card-img rounded-xl sh-6 sw-6" src={workex.icon} alt="Workex Organization" />:<div className="bg-gradient-light sw-6 sh-6 rounded-xl">
                <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                <i className={`text-forground bi-person-badge`} style={{ 'fontSize': '1.8rem' }} />
                </div>
              </div>}
          </Col>
          <Col>
            <div className="mt-1 mb-0 font-size-1rem font-weight-bold">
              {workex.position} @ {workex.orgName}
              {(workex.certificate && workex.certificate!=="")?<a href={workex.certificate} target="_blank" variant="foreground" size="sm" title="View Certificate" className="btn-icon btn-icon-only hover-outline ms-1" rel="noreferrer"><CsLineIcons icon="content" /></a>:''}
            </div>
            <p className="text-muted">{format(new Date(workex.fromDate), 'dd MMM, yyyy')}{(workex.tillDate && workex.tillDate!=="")?` - ${workex.tillDate}`:''}</p>
          </Col>
        </Row>
        {workex.description && !_.isEmpty(workex.description) && 
        <Card.Text className="mt-4 mb-4 ms-1">
          <ul>
            {workex.description.map((desc)=>{return <><li key={desc.questionId}><p className="text-primary mb-0" >{desc.question}</p><p dangerouslySetInnerHTML={{ __html: desc.questionResponse }} /></li></>})}
          </ul>
        </Card.Text>
        }
      </Card.Body>
    </Card>
  );
};

export default WorkexCard;
WorkexCard.propTypes = {
  user: PropTypes.object.isRequired,
  workex: PropTypes.object.isRequired
}